import React, { useRef } from "react";
import { Button } from "react-bootstrap";
import "./Cetegory_Banner.css";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

import { faAngleLeft, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Cetegory_Banner() {
  const swiperRef = useRef(null);

  return (
    <section className="Cetegory_Banner">
      
      {/* Swiper */}
      <Swiper
        slidesPerView={1}
        loop={true}
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        className="banner-swiper"
      >
        <SwiperSlide>
          <div className="banner_image">
            <img
              src="/assets/Images/Home/Home_Category_Banner/Banner/banner_1.png"
              alt="banner1"
              className="Cetegory_Banner_img"
            />
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div className="banner_image">
            <img
              src="/assets/Images/Home/Home_Category_Banner/Banner/banner_1.png"
              alt="banner2"
              className="Cetegory_Banner_img"
            />
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div className="banner_image">
            <img
              src="/assets/Images/Home/Home_Category_Banner/Banner/banner_1.png"
              alt="banner3"
              className="Cetegory_Banner_img"
            />
          </div>
        </SwiperSlide>
      </Swiper>

      {/* Buttons */}
      <div className="Banenr_Slider">
        <div className="slider-controls">
          
          <Button
            className="slider-btn"
            onClick={() => swiperRef.current?.slidePrev()}
          >
            <FontAwesomeIcon icon={faAngleLeft} />
          </Button>

          <Button
            className="slider-btn"
            onClick={() => swiperRef.current?.slideNext()}
          >
            <FontAwesomeIcon icon={faAngleRight} />
          </Button>

        </div>
      </div>

    </section>
  );
}

export default Cetegory_Banner;